import { render, staticRenderFns } from "./BxbkLogin.vue?vue&type=template&id=65c44a66&scoped=true"
import script from "./BxbkLogin.vue?vue&type=script&lang=js"
export * from "./BxbkLogin.vue?vue&type=script&lang=js"
import style0 from "./BxbkLogin.vue?vue&type=style&index=0&id=65c44a66&prod&scoped=true&lang=css"
import style1 from "./BxbkLogin.vue?vue&type=style&index=1&id=65c44a66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c44a66",
  null
  
)

export default component.exports